<script>
import { toMoney, getNumber, toPercent } from '@utils/Format'

/**
 * Componente para apresentar indicador de diferença.
 * Ou seja, um ícone de gráfico (subindo ou descendo) e o valor em si.
 */
export default {
  name: 'GeneralValueDiff',
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    valueFormatted: {
      type: [String, Number],
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    initialValue: {
      type: Number,
      default: null,
    },
    finalValue: {
      type: Number,
      default: null,
    },
    type: {
      type: String,
      default: 'percent',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    numericValue() {
      return typeof this.value === 'string' ? getNumber(this.value) : this.value
    },
    formattedValueNormalized() {
      if (typeof this.valueFormatted === 'string') {
        return this.valueFormatted
      }
      const MAP_FORMAT = {
        percent: toPercent,
        money: toMoney,
      }
      return MAP_FORMAT[this.type](this.valueFormatted)
    },
    displayValue() {
      return (
        this.formattedValueNormalized ||
        (this.numericValue === 0
          ? ` ${this.numericValue}`
          : `${this.numericValue > 0 ? '+ ' : '- '}${Math.abs(
              this.numericValue
            )}`)
      )
    },
    tooltipContent() {
      if (this.initialValue !== null && this.finalValue !== null) {
        return this.generatePerformanceTooltip(
          this.initialValue,
          this.finalValue
        )
      }
      return this.tooltip
    },
    hasTooltip() {
      return this.tooltipContent !== ''
    },
    containerClass() {
      let baseClass = this.small
        ? 'text-xs ml-3/4rem text-center mt-1/2rem'
        : 'text-heading-small-medium ml-3/4rem text-center mt-1/2rem'

      baseClass += this.numericValue > 0 ? ' bg-success' : ' bg-danger'
      return baseClass
    },
    containerStyle() {
      return {
        borderRadius: '2px',
        width: 'fit-content',
        ...(this.small
          ? { minWidth: '2rem', padding: '2px 4px' }
          : { minWidth: '4rem', padding: '3px 6px' }),
      }
    },
  },
  methods: {
    generatePerformanceTooltip(initialValue, finalValue) {
      return `Valor inicial: ${toMoney(initialValue)}
              Valor final: ${toMoney(finalValue)}`
    },
  },
}
</script>

<template>
  <div
    :class="containerClass"
    :style="containerStyle"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-tooltip :disabled="!hasTooltip" top>
      <template v-slot:activator="{ on, attrs }">
        <div
          class="full-center flex-row"
          style="gap: 6px"
          v-bind="attrs"
          v-on="on"
        >
          <icon-svg
            :name="numericValue < 0 ? 'received-new-ux' : 'send-new-ux'"
            :size="small ? 12 : 16"
          />
          {{ displayValue }}
        </div>
      </template>
      <span v-html="tooltipContent.replace(/\n/g, '<br />')"></span>
    </v-tooltip>
  </div>
</template>
